export default __webpack_public_path__ + "static/media/x-shift_thumb.14459ca7.png";